import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatDialogRef } from '@angular/material/dialog';

import { OTP_ACTION } from '@app/models';
import { ModalService } from '@app/services/modal/modal.service';
import { USER_AUTOINVEST_CONTRACT } from './user-autoinvest-contract.const';
import { ContractService, UserService } from '@app/services';

@Component({
   selector: 'mnf-user-settings-autoinvest-contract',
   templateUrl: './user-settings-autoinvest-contract.component.html',
   styleUrls: ['./user-settings-autoinvest-contract.component.scss']
})
export class UserSettingsAutoinvestContractComponent implements OnInit {

   contract: SafeHtml;

   user: any;
   autoinvestData: any;

   signatureIsUrl: boolean;
   userSignature: string;
   signatureDate: number;
   userName: string;

   months = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'];

   constructor(private dialogRef: MatDialogRef<any>, private domSanitizer: DomSanitizer, private modalServ: ModalService, private userServ: UserService, private contractService: ContractService) { }

   ngOnInit(): void {
      this.signatureIsUrl = !(/data:/.test(this.user?.info?.signature));
      this.userSignature = this.user?.info?.signature;
      this.signatureDate = this.user?.wallet?.createAt || '';

      const today = new Date(this.signatureDate);
      const signatureDate = `${String(today.getDate()).padStart(2, '0')} DE ${this.months[today.getMonth()]} DE ${today.getFullYear()}`;

      this.userName = `${this.user?.name || ''} ${this.user?.fatherSurname || ''} ${this.user?.motherSurname || ''}`;
      this.contract = this.domSanitizer.bypassSecurityTrustHtml(
         USER_AUTOINVEST_CONTRACT
            .replace(/{NAME}/g, this.userName)
            .replace('{{today}}', signatureDate)
      );
   }

   /** Si data es texto plano o una url */
   getUrlSignature(url: string) {
      const isData = /data:/;
      return !isData.test(url);
   }

   getTrustImg(img: string) {
      return this.domSanitizer.bypassSecurityTrustUrl(img);
   }

   acceptAutoinvestContract() {      
      const types = [];
      if (this.autoinvestData?.selectedOption == 'allProjects') { types.push("variable"); types.push("fixed"); }
      if (this.autoinvestData?.selectedOption == 'variable') { types.push("variable"); }  
      if (this.autoinvestData?.selectedOption == 'fixed') { types.push("fixed"); }
      
      this.modalServ.sendAndOpenModalOTP(OTP_ACTION.ACCEPT_AUTOINVEST, {
         title: 'Aceptar contrato de autoinversión',
         header: 'Contrato de autoinversión',
         message: `Para poder continuar con el proceso deberás ingresar el código de verificación que te hemos enviado por ${this.user.otpMethod === 'email' ? 'Email' : 'SMS'}.`,
      }).subscribe((token) => {
         if (token) {
   
            const types = [];
            if (this.autoinvestData?.selectedOption == 'allProjects') { types.push("variable"); types.push("fixed"); }
            if (this.autoinvestData?.selectedOption == 'variable') { types.push("variable"); }  
            if (this.autoinvestData?.selectedOption == 'fixed') { types.push("fixed"); }
   
            const newObj = {
               minAmount: 1000,
               type: types
            };
            
            this.userServ.acceptAutoninvestContract(token, newObj).subscribe((accepted) => {
               this.userServ.getContractPDFAutoInvest().subscribe();
               // Emitir que el contrato fue aceptado
               this.contractService.acceptContract(true);
               let m = this.modalServ.openModalConfirmMovementAutoInvest(accepted, true);
               m.afterClosed().subscribe((res) => {
                     this.dialogRef.close();
               })
            });
         }
      });
   }

}
